/* unplugin-vue-components disabled */import { render } from "./add-modal.vue?vue&type=template&id=30a2a82e&scoped=true"
import script from "./add-modal.vue?vue&type=script&lang=js"
export * from "./add-modal.vue?vue&type=script&lang=js"

import "./add-modal.vue?vue&type=style&index=0&id=30a2a82e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a2a82e"],['__file',"src/pages/sh-contacts/add-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30a2a82e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30a2a82e', __exports__)) {
    api.reload('30a2a82e', __exports__)
  }
  
  module.hot.accept("./add-modal.vue?vue&type=template&id=30a2a82e&scoped=true", () => {
    api.rerender('30a2a82e', render)
  })

}


export default __exports__